import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import Icon from "../Icon/Icon";
import "./IconButton.scss";

export default function IconButton(props) {
  const iconButtonClasses = cx(
    "IconButton__container", 
    {"transparentBackground": props.transparentBackground},
    props.className, 
  );

  return (
    <button
      aria-expanded={props.ariaExpanded}
      aria-haspopup={props.ariaHaspopup}
      aria-label={props.ariaLabel}
      className={iconButtonClasses}
      disabled={props.disabled}
      onClick={props.onClick}
      onMouseDown={props.onMouseDown}
      ref={props.buttonRef}
      tabIndex={props.tabIndex}
    >
      <Icon
        className={props.iconClass}
        desc={props.desc}
        id={props.id}
        name={props.icon}
        role={props.role}
        styles={props.styles}
        title={props.title}
      />
    </button>
  );
}

// Props marked with a ** need to be translated strings.
IconButton.propTypes = {
  ariaExpanded: PropTypes.bool,
  ariaHaspopup: PropTypes.bool,
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
  desc: PropTypes.string.isRequired, //**
  disabled: PropTypes.bool,
  iconClass: PropTypes.string,
  id: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  role: PropTypes.oneOf([
    "button",
    "link",
    "search"
  ]).isRequired,
  styles: PropTypes.object,
  transparentBackground: PropTypes.bool,
  title: PropTypes.string.isRequired //**
};

IconButton.defaultProps = {
  role: "button",
  tabIndex: 0,
  transparentBackground: false
};
